import { render, staticRenderFns } from "./QuestionnaireLogin.vue?vue&type=template&id=4554e954&scoped=true&"
import script from "./QuestionnaireLogin.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireLogin.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireLogin.vue?vue&type=style&index=0&id=4554e954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554e954",
  null
  
)

export default component.exports